const muiBreakpointLg = {
  breakpoints: {
    values: {
      lg: 1480,
    },
  },
}

export { muiBreakpointLg }
